const settingsRoutes = [
  {
    path: '/municipality-messages',
    name: 'MunicipalityMessages',
    component: () => import(/* webpackChunkName: "auth" */ './pages/municipality-messages.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/municipality-message-edit/:id',
    name: 'MunicipalityMessageEdit',
    component: () => import(/* webpackChunkName: "add-permit-price" */ './pages/municipality-message-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
];

export default settingsRoutes;
